import { createSelector } from 'reselect'
import storage from 'util/storage'
import { selectIsEcommerce } from 'selectors/account'
import {
  selectCurrentUserIsAdmin,
  selectCurrentUserIsOwner,
} from 'ducks/currentUser'
import { selectFlag } from 'ducks/flags'
import selectIntegrationCredentialsAreLoaded from './selectIntegrationCredentialsAreLoaded'
import selectIntegrationCredentialsForProvider from './selectIntegrationCredentialsForProvider'

const selectShowShopifyInstall = createSelector(
  selectIsEcommerce,
  selectCurrentUserIsAdmin,
  selectCurrentUserIsOwner,
  selectFlag,
  selectIntegrationCredentialsAreLoaded,
  state =>
    selectIntegrationCredentialsForProvider(state, { provider: 'SHOPIFY_V2' }),
  (
    isEcommerce,
    isAdmin,
    isOwner,
    getFlag,
    areCredentialsLoaded,
    shopifyCredentials
  ) => {
    const isManager = isOwner || isAdmin

    return (
      storage.get('showShopifyV2') &&
      isEcommerce &&
      isManager &&
      getFlag('hide-shopify-v2-sidebar-install') === false &&
      areCredentialsLoaded &&
      !shopifyCredentials
    )
  }
)

export default selectShowShopifyInstall
